/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Cannot_Move_Into_Self_ToastInputs */

const en_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot move a folder into itself`)
};

const fr_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de deplacer un dossier dans lui-meme`)
};

const de_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Ordner kann nicht in sich selbst verschoben werden.`)
};

const it_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile spostare una cartella in se stessa`)
};

const ru_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невозможно переместить папку саму в себя.`)
};

const es_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede mover una carpeta hacia sí misma`)
};

const zh_cn2_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法将文件夹移动到自身内部。`)
};

const ja_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダをそれ自体の中に移動することはできません`)
};

const hi_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी फ़ोल्डर को उसी फ़ोल्डर में स्थानांतरित नहीं किया जा सकता`)
};

const pt_pt2_explorer_table_cannot_move_into_self_toast = /** @type {(inputs: Explorer_Table_Cannot_Move_Into_Self_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não é possível mover uma pasta para dentro dela mesma.`)
};

/**
* | output |
* | --- |
* | "Cannot move a folder into itself" |
*
* @param {Explorer_Table_Cannot_Move_Into_Self_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_cannot_move_into_self_toast = /** @type {((inputs?: Explorer_Table_Cannot_Move_Into_Self_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Cannot_Move_Into_Self_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "de") return de_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "it") return it_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "ru") return ru_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "es") return es_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "ja") return ja_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "hi") return hi_explorer_table_cannot_move_into_self_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_cannot_move_into_self_toast(inputs)
	return en_explorer_table_cannot_move_into_self_toast(inputs)
});